import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import DraggableDialogWrapper from 'components/ConfirmProductActions/DraggableDialogWrapper';
import InfoIcon from 'components/ConfirmProductActions/images/informational.png';
import styled from '@emotion/styled';

const DialogPageProps = {
  width: 764,
  height: 670,
  maxWidth: '100%',
  background: '#FAFAFA',
};

const DialogTextProvider = styled(Typography)({
  fontWeight: 500,
  fontSize: 32,
  lineHeight: '32px',
  color: '#3C4350',
  marginTop: 32,
});

const DialogTextSubProvider = styled(Typography)({
  fontWeight: 400,
  fontSize: 24,
  lineHeight: '36px',
  color: '#0F1214',
  margin: '32px auto',
  maxWidth: 699,
  textAlign: 'center',
  letterSpacing: '0.25px',
});

const DialogContentBox = styled(DialogContent)({
  width: '100%',
  textAlign: 'center',
  padding: 0,
  cursor: 'move',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

const DialogActionsProductButton = styled(Button)({
  textAlign: 'center',
  borderRadius: 6,
  border: '1px solid rgb(98 106 122 / 50%)',
  background: 'white',
  padding: '17.5px 30px',
  '&:hover': {
    border: '1px solid #626A7A',
    background: 'white',
  },
});

const DialogActionsProductConfirmButton = styled(Button)({
  textAlign: 'center',
  padding: '17.5px 30px',
  borderRadius: '6px',
  boxShadow: 'initial',
  border: '1px solid #2D7FF9',
  '&:hover': {
    border: '1px solid rgb(31, 88, 174)',
    boxShadow: 'initial',
  },
});

const DialogActionsProductBox = styled(DialogActions)({
  minHeight: '102px',
  borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
});

const DialogActionsTypography = styled(Typography)({
  fontWeight: 700,
  lineHeight: '18.75px',
});

const DialogActionsImg = styled(Box)({
  width: '68px',
  height: '68px',
});

const UnpublishedInventoryChangesModal = ({ open, onCancel, onLeave }) => {
  const { t } = useTranslation();

  // console.log('🚨 UnpublishedInventoryChangesModal - Render:', { open });

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        console.log('🚨 Modal close triggered, reason:', reason);
        if (reason !== 'backdropClick') {
          onCancel();
        }
      }}
      disableEscapeKeyDown
      aria-labelledby="draggable-dialog-content"
      fullWidth={true}
      PaperComponent={DraggableDialogWrapper}
      PaperProps={{
        sx: DialogPageProps,
      }}
    >
      <DialogContentBox id="draggable-dialog-content">
        <DialogActionsImg component="img" src={InfoIcon} alt="info" />
        <DialogTextProvider>
          {t(
            'inventory.unpublished_changes_title',
            'Unpublished Inventory Changes'
          )}
        </DialogTextProvider>
        <DialogTextSubProvider>
          {t(
            'inventory.unpublished_changes_message',
            'You have unpublished changes to the provider inventory that have not been published yet. Would you like to stay and publish the updates now, or leave and publish them later?'
          )}
        </DialogTextSubProvider>
      </DialogContentBox>
      <DialogActionsProductBox>
        <DialogActionsProductButton variant="outlined" onClick={onCancel}>
          <DialogActionsTypography color="#626A7A">
            {t('orders.cancel', 'Cancel')}
          </DialogActionsTypography>
        </DialogActionsProductButton>
        <DialogActionsProductConfirmButton
          variant="contained"
          onClick={onLeave}
        >
          <DialogActionsTypography color="#fff">
            {t('inventory.leave', 'Leave')}
          </DialogActionsTypography>
        </DialogActionsProductConfirmButton>
      </DialogActionsProductBox>
    </Dialog>
  );
};

export default UnpublishedInventoryChangesModal;
